import WithRoutePermission from "shared/components/HOC/WithRoutePermission";
import { MODULES, SCREENS, SUBMODULES } from "utils/constants";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.BROKER.NOTIFICATIONS.LIST.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.NOTIFICATION]: SUBMODULES.BROKER_LIST }}
        WrappedComponent={List}
      />
    ),
  },
];

export default routes;
